<template>
    <div class="trainer module module--space-default">
        <div class="trainer__top" v-if="trainer">
            <div class="container trainer__top__container">
                <div class="trainer__main">
                    <div class="trainer__image">
                        <v-lazy-image :src="trainer.profileImageUrl"></v-lazy-image>
                    </div>
                    <div class="trainer__main__block">
                        <h1 class="trainer__title h1">{{trainer.name}}</h1>
                        <div class="trainer__info text text--large">
                            <strong>{{trainer.totalScore}}</strong> <translate>trac_score</translate>
                            <span class="divider">|</span>
                            {{trainer.location}}
                        </div>
                        <div class="trainer__ig" v-if="trainer.instagramHandle">
                            <a :href="`https://www.instagram.com/${ig}`" target="_blank" class="trainer__ig__link text text--large" v-for="ig in igHandles" :key="ig"  @click.prevent="outboundLinkClicked(`https://www.instagram.com/${ig}`)">
                                @{{ig}}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="trainer__side">
                    <div class="trainer__description text text--small">{{trainer.bio}}</div>
                    <div class="trainer__follower text text--large">
                        <div class="trainer__follower__item">
                            <strong>{{trainer.followingCount}}</strong> <translate>following</translate>
                        </div>
                        <div class="trainer__follower__item">
                            <strong>{{trainer.followersCount}}</strong> <translate>followers</translate>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="trainer__list" v-if="trainer">
            <WorkoutList :workouts="workouts"></WorkoutList>
        </div>

        <div class="trainer__loader" v-if="!trainer">
            <Loader></Loader>
        </div>

    </div>
</template>

<script>
import * as api from '../api'
import WorkoutList from "@/components/WorkoutList.vue";

import { addTrackingObject } from "@/utils/tracking"
import { captureOutboundLink } from '@/utils/tracking';

 export default {
    name: 'Trainer',
    components: {
        WorkoutList,
    },
    data() {
        return {
            id: this.$route.params.id,
            trainer: false,
            workouts: false,
        }
    },
    mounted() {
        this.fetchData()

        addTrackingObject({subSection: "home", screenName: "trainerDetail"}, {type: "trainer", value: "web_trainer_detail_page"});
    },
    computed: {
        igHandles() {
            if(this.trainer && this.trainer.instagramHandle) {
                return this.trainer.instagramHandle.split(',')
            } else {
                return false
            }
        }
    },
    methods: {
        async fetchData() {
            try {
                const trainerResponse = await api.profiles.profile({id: this.id})
                const workoutsResponse = await api.workout.all({params: {trainer: this.id}})
                this.trainer = trainerResponse.data.data
                this.workouts = workoutsResponse.data.data
            } catch(error) {
                console.error(error)
            }
        },
        outboundLinkClicked(url) {
            captureOutboundLink(url, {navigation: {subSection: "home", screenName: "trainerDetail"}, event: {type: "trainer", value: "web_trainer_instagram"}})
            return false
        }
    }
 }
</script>

<style lang="scss" scoped>
.trainer {
    $block: &;

    &__loader {
        display: flex;
        justify-content: center;
    }

    &__top {
        border-bottom: 1px solid rgba(black, 0.1);
        padding-bottom: 60px;

        @include mq($until: tablet) {
            padding-bottom: 40px;
        }

        &__container {
            display: flex;
            justify-content: space-between;

            @include mq($until: tablet-landscape) {
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
        }
    }

    &__main {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 40px;

        @include mq($until: tablet) {
            flex-direction: column;
            text-align: center;
        }
    }

    &__side {
        max-width: 520px;
        width: 50%;
        margin-left: 40px;
        padding-top: 10px;

        @include mq($until: tablet-landscape) {
            width: 100%;
            margin: 0;
            text-align: center;
            padding: 0;
        }
    }

    &__image {
        position: relative;
        width: 160px;
        height: 160px;
        margin-right: 40px;
        flex-shrink: 0;

        @include mq($until: tablet) {
            margin: 0 0 20px;
        }

        img {
            @include object-fit;
            border-radius: 100%;
        }
    }

    &__title {
        margin-bottom: 6px;
    }

    &__info {
        .divider {
            margin: 0 10px;
        }
    }

    &__ig {
        margin-top: 20px;

        &__link {
            display: block;
        }
    }

    &__follower {
        display: inline-flex;
        align-items: center;
        margin-top: 20px;
        border: 1px solid rgba(black, 0.2);

        &__item {
            text-align: center;
            padding: 16px 10px 18px;
            min-width: 160px;

            &:not(:first-child) {
                border-left: 1px solid rgba(black, 0.2);
            }
        }
    }

    &__list {
        padding-top: 70px;

        @include mq($until: tablet) {
            padding-top: 50px;
        }
    }
}
</style>